import hostname from "./config.host";
import { fetchWrapper } from "./fetch-wrapper";

const apiUrl: string = `${hostname}/aladdin_api/v1`;

function getLeadsReport(
  oauthTokenHeader: string,
  data: {
    website_shared_uid: string[];
    date_from: string;
    date_to: string;
    page: number;
    page_size: number;
    search?: string;
    report_status?: string;
    brand_uid?: string[];
  },
) {
  return fetchWrapper.post(
    `${apiUrl}/partners/brand_leads_report/`,
    data,
    oauthTokenHeader,
  );
}

function reportLeads(oauthTokenHeader: string, data: { lead_ids: number[] }) {
  return fetchWrapper.post(
    `${apiUrl}/partners/brand_leads/report/`,
    data,
    oauthTokenHeader,
  );
}

export const leadsManagementService = {
  getLeadsReport,
  reportLeads,
};
